import React, { Component } from 'react';

class CollapsablePanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false
        }

        this.onClickOpen = this.onClickOpen.bind(this);
        this.onClickClose = this.onClickClose.bind(this);
    }

    onClickOpen() {
        this.setState({ collapsed: false });
    }

    onClickClose() {
        this.setState({ collapsed: true });
    }

    async componentDidMount() {
        if(this.props.isCollapsed) {
            this.setState({ collapsed: true });
        }
    }

    render() {
        // console.log('this.props.panelContent.isMobile',this.props.panelContent.props.isMobile)

        return (<div className="edb-row" style={{display: 'flex', width: '100%'}}>

            <div className="edb-col edb-left adap-gray collapsable-panel" style={{ width: (this.props.size || 320) +"px", display: this.state.collapsed ? "none" : "" }}>
                <button className="edb-button adap-text-darkergray edb-large edb-text-bold" onClick={this.onClickClose}>
                    <i className="fas fa-sliders-h" style={{marginRight: "4px"}}></i>
                    {this.props.closeText}
                </button>
                {React.cloneElement(this.props.panelContent, {
                    onClickClose: this.onClickClose
                })}
            </div>

            <div className="edb-rest" style={{flexGrow: '1'}}>

                <button className="edb-button adap-text-darkergray edb-large edb-left edb-padding edb-text-bold" onClick={this.onClickOpen} style={{display: !this.state.collapsed ? "none" : ""}}>
                    <i className="fas fa-sliders-h" style={{marginRight: "4px"}}></i>
                    {this.props.openText}
                </button>

                {this.props.mainContent}
            </div>
        </div>);
    }
}

export default CollapsablePanel;